import {
    hackHeader,
    inputNumb,
    columnCustom,
    footer,
} from "../../mappers/CoreSquad.js";
import {
    hackHeader as hh,
    inputNumb as iN,
    columnCustom as cc,
    footer as fo,
} from "../../mappers/Staff.js";
import {
    hackHeader as hh1,
    inputNumb as iN1,
    columnCustom as cc1,
    footer as fo1,
} from "../../mappers/Umpire.js";
import {
    hackHeader as hh2,
    inputNumb as iN2,
    columnCustom as cc2,
    footer as fo2,
} from "../../mappers/ReportStaff.js";
import {
    hackHeader as hh3,
    inputNumb as iN3,
    columnCustom as cc3,
    footer as fo3,
} from "../../mappers/ReportSquad.js";
import {
    hackHeader as hh4,
    inputNumb as iN4,
    columnCustom as cc4,
    footer as fo4,
} from "../../mappers/Payments.js";

import {
    hackHeader as hh5,
    inputNumb as iN5,
    columnCustom as cc5,
    footer as fo5,
} from "../../mappers/Players.js";

export function getComponentConfig(componentCheck, dataPath, props) {
    const componentMap = {
        dhbplayer_match_report: {
            header: () => hh3(props),
            inputField: iN3,
            columnCustom: cc3,
            footer: fo3,
        },
        dhbstaff_match_report: {
            header: hh2,
            inputField: iN2,
            columnCustom: cc2,
            footer: fo2,
        },
        dhbumpire_selection_match: {
            header: () => hh1(props),
            inputField: iN1,
            columnCustom: cc1,
            footer: fo1,
        },
        dhbumpire_costs: {
            header: hh4,
            inputField: iN4,
            columnCustom: cc4,
            footer: fo4,
            state: { roles: [] },
        },
    };

    const pathMap = {
        "/squad": {
            header: () => hackHeader(props),
            inputField: inputNumb,
            columnCustom,
            footer,
        },
        "/coreSquad": {
            header: () => hackHeader(props),
            inputField: inputNumb,
            columnCustom,
            footer,
        },
        "/playersHome": {
            header: () => hh5(props),
            inputField: iN5,
            columnCustom: cc5,
            footer: fo5,
        },
        "/playersAway": {
            header: () => hh5(props),
            inputField: iN5,
            columnCustom: cc5,
            footer: fo5,
        },
        "/additionalSquad": {
            header: () => hh(props),
            inputField: iN,
            columnCustom: cc,
            footer: fo,
        },
        "/staffHome": {
            header: () => hh(props),
            inputField: iN,
            columnCustom: cc,
            footer: fo,
        },
        "/staffAway": {
            header: () => hh(props),
            inputField: iN,
            columnCustom: cc,
            footer: fo,
        },
        "/squadHome": {
            header: hh3,
            inputField: iN3,
            columnCustom: cc3,
            footer: fo3,
        },
        "/squadAway": {
            header: hh3,
            inputField: iN3,
            columnCustom: cc3,
            footer: fo3,
        },
    };

    return (
        componentMap[componentCheck] ||
        pathMap[dataPath] || {
            header: () => {},
            inputField: () => {},
            columnCustom: () => {},
            footer: () => {},
        }
    );
}
